module.exports = __webpack_public_path__ + "img/option-b.2027e98b.png";